import React, { useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import { EReceptRow } from '../../../../Components/eRecept/List/EReceptListItem';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import useNotification from '../../../../Hooks/useNotification.hook';
import useApiClient from '../../../Base/Hooks/useApiClient';
import Loading from '../../../../Components/Loading';
import { useCancelP1PrescriptionMutation } from '../../../../graphql/graphql';

interface Props {
	item: EReceptRow;
	onSuccess: () => void;
}

const validationSchema = yup.object({
	note: yup.string().notRequired(),
});

const P1PrescriptionCancel: React.FC<Props> = ({ item, onSuccess }) => {
	const [isLoading, setIsLoading] = useState(false);
	const { showNotificationSuccess } = useNotification();
	const { displayError, displayGQLError } = useApiClient();
	const [deletePrescription] = useCancelP1PrescriptionMutation();

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: { note?: string }) => {
		setIsLoading(true);

		try {
			const response = await deletePrescription({
				input: {
					id: item.id,
					note: values.note,
				},
			});

			displayGQLError(response);
			if ('data' in response) {
				showNotificationSuccess({
					content: 'component.p1PrescriptionListItem.deleteSuccess',
				});

				onSuccess?.();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<FormWrapper formMethods={formMethods}>
			<TextAreaField
				name='note'
				label='component.p1PrescriptionCancel.cancelationNote'
				isWrapped
			/>
			<SubmitButton
				onSubmit={handleSubmit}
				title='component.p1PrescriptionCancel.submitButton'
			/>
		</FormWrapper>
	);
};

export default P1PrescriptionCancel;
